import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AvailabilitySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AvailabilitySVG;
